import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_Deposit_times_are_shown_here_a_ELL,
  TXTWCL_If_you_want_to_learn_more_abou_ELL,
  TXTWCL_Some_payment_methods_may_take__ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_Some_payment_methods_may_take__ELL} />{' '}
    <Translation {...TXTWCL_Deposit_times_are_shown_here_a_ELL} />
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.RealMoney}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_If_you_want_to_learn_more_abou_ELL}
    />
  </>
);

export default HelpSectionContent;
